const ResponsiveHeadshot = ({
  headshotNumber, // 1 or 2
  alt = "Wendy Toh",
  className = "bio-headshot",
  ...props
}) => {
  const baseName = `WendyHeadshot${headshotNumber}`;

  // Desktop sources (400x400 and 800x800 for retina)
  const desktopWebpSrc = `/${baseName}.webp`;
  const desktopWebp2x = `/${baseName}@2x.webp`;

  // Mobile sources (200x200 and 400x400 for retina)
  const mobileWebpSrc = `/${baseName}-mobile.webp`;
  const mobileWebp2x = `/${baseName}-mobile@2x.webp`;

  // Fallback to original JPG
  const fallbackSrc = `/${baseName}.jpg`;

  return (
    <picture>
      {/* Mobile WebP sources */}
      <source
        media="(max-width: 768px)"
        srcSet={`${mobileWebpSrc} 1x, ${mobileWebp2x} 2x`}
        type="image/webp"
        sizes="200px"
      />

      {/* Desktop WebP sources */}
      <source
        srcSet={`${desktopWebpSrc} 1x, ${desktopWebp2x} 2x`}
        type="image/webp"
        sizes="400px"
      />

      {/* Fallback image */}
      <img
        src={fallbackSrc}
        alt={alt}
        className={className}
        width="400"
        height="400"
        loading="lazy"
        {...props}
      />
    </picture>
  );
};

export default ResponsiveHeadshot;
